import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const DataContext = createContext(null);

function daysAgo(n) {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString().slice(0, 10);
}

export function DataProvider({ children }) {
  const [masters, setMasters] = useState({ clients: [], campaigns: [], managers: [], vias: [], verticals: [] });
  const [filters, setFilters] = useState({
    start: daysAgo(29),
    end: new Date().toISOString().slice(0, 10),
    client_id: "all",
    campaign_id: "all",
    manager_id: "all",
    via_id: "all",
    currency: "INR",
    granularity: "daily",
  });

  const reloadMasters = async () => {
    const kinds = ["clients", "campaigns", "managers", "vias", "verticals"];
    const res = await Promise.all(kinds.map((k) => api.get(`/masters/${k}`)));
    setMasters(Object.fromEntries(kinds.map((k, i) => [k, res[i].data])));
  };

  useEffect(() => {
    reloadMasters().catch(() => {});
  }, []);

  const nameMap = useMemo(() => {
    const m = {};
    Object.values(masters).forEach((list) => list.forEach((x) => (m[x.id] = x.name)));
    return m;
  }, [masters]);

  return (
    <DataContext.Provider value={{ masters, reloadMasters, filters, setFilters, nameMap }}>
      {children}
    </DataContext.Provider>
  );
}

export const useData = () => useContext(DataContext);
export { daysAgo };
